export default "__VITE_ASSET__9399c165__"